import { render, staticRenderFns } from "./TablaNuevaSiniestralProduccionLineaNegocio.vue?vue&type=template&id=1cc0ea4f"
import script from "./TablaNuevaSiniestralProduccionLineaNegocio.vue?vue&type=script&lang=js"
export * from "./TablaNuevaSiniestralProduccionLineaNegocio.vue?vue&type=script&lang=js"
import style0 from "./TablaNuevaSiniestralProduccionLineaNegocio.vue?vue&type=style&index=0&id=1cc0ea4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports